import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import bannerImg from '../assets/images/banner.png';

const CorporateSecurity = () => {
  return (
    <div className="service-detail-page">
      
      {/* INJECTED STYLES FOR MOBILE RESPONSIVENESS */}
      <style>
        {`
          /* --- REMOVE GLOBAL HERO ARROW JUST FOR THIS PAGE --- */
          .service-hero::after {
            display: none !important;
          }

          /* --- PREMIUM MOBILE RESPONSIVE FIXES --- */
          @media (max-width: 992px) {
            .service-text-grid { grid-template-columns: 1fr !important; gap: 3rem !important; }
            .process-steps { grid-template-columns: 1fr !important; gap: 2rem !important; }
          }

          @media (max-width: 768px) {
            /* Hero adjustments to prevent overlap with header */
            .service-hero { padding: 13rem 1.5rem 5rem 1.5rem !important; }
            .service-hero h1 { font-size: 2.5rem !important; line-height: 1.2 !important; }
            .service-hero p.subtitle { font-size: 1.1rem !important; }

            /* Enforce container boundaries */
            .container { padding-left: 1.5rem !important; padding-right: 1.5rem !important; }

            /* Spacing fixes */
            .service-main-content { padding-top: 4rem !important; padding-bottom: 4rem !important; }
            .service-process-section { padding-top: 4rem !important; padding-bottom: 4rem !important; }
            
            /* Fix CTA layout overlapping screen edges */
            .sleek-cta-banner-override { flex-direction: column !important; text-align: center !important; padding: 3rem 1.5rem !important; }
            .sleek-cta-banner-override > div { min-width: 100% !important; text-align: center !important; }
            .sleek-cta-banner-override p { margin: 0 auto !important; }
          }
        `}
      </style>

      {/* 1. UNIFIED HERO */}
      <section className="service-hero">
        <div className="container text-center">
          <h1>Corporate Security</h1>
          <p className="subtitle">
            Safeguarding your people, property, and daily operations with professional, intelligence-led security.
          </p>
        </div>
      </section>

      {/* 2. MAIN CONTENT & SIDEBAR */}
      <section className="service-main-content container" style={{ paddingTop: '6rem', paddingBottom: '6rem' }}>
        <div className="service-text-grid">
          
          {/* Left Column: Description */}
          <div className="service-description">
            <h2 style={{ marginTop: 0 }}>Securing Your Commercial Environment</h2>
            <p>
              Effective security is about more than preventing incidents. It is about creating environments where people can work, visit and operate with confidence.
            </p>
            <p>
              Our corporate security teams support commercial properties, workplaces and business environments through proactive security, access control and operational support. Combining customer service with security awareness, our officers become an extension of your team, helping to protect people, property and reputation whilst supporting the day-to-day needs of your organisation. 
            </p>
            <p>
              All personnel are vetted to BS7858 standards and hold valid SIA licences, providing a professional and dependable presence across your estate.
            </p>

            <h3>Core Capabilities</h3>
            <ul className="custom-bullet-list">
              <li>SIA-licensed security officers and front-of-house personnel.</li>
              <li>Concierge, reception and visitor management services.</li>
              <li>Access control and site security management.</li>
              <li>Customer service, conflict management and incident response.</li>
              <li>Mobile patrols, keyholding and alarm response services.</li>
              <li>Building security, lock-up and unlock procedures.</li>
            </ul>
          </div>

          {/* Right Column: Premium Contact Sidebar */}
          <aside className="service-sidebar" style={{ backgroundColor: 'var(--color-primary-navy)', color: 'var(--color-white)', padding: '3rem 2.5rem', borderRadius: '12px', boxShadow: '0 20px 40px rgba(0,0,0,0.15)', height: 'fit-content', border: 'none' }}>
            <h3 style={{ color: 'var(--color-white)', marginBottom: '1rem', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '1rem' }}>Secure Your Workspace</h3>
            <p style={{ fontSize: '0.95rem', color: 'var(--color-secondary-light)', lineHeight: '1.6', marginBottom: '2rem' }}>
              Speak directly with our corporate security team to discuss your bespoke operational requirements in complete confidence.
            </p>
            <div className="sidebar-contact" style={{ borderTop: 'none', paddingTop: 0, marginTop: 0 }}>
              <span style={{ fontSize: '0.85rem', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', color: 'var(--color-secondary-grey)', display: 'block', marginBottom: '0.5rem' }}>24/7 Operations Desk</span>
              <div className="phone-number" style={{ fontFamily: 'var(--font-heading)', fontSize: '1.8rem', fontWeight: '800', color: 'var(--color-white)', margin: '0 0 2rem 0' }}>01270 446302</div>
              <Link to="/contact" className="btn btn-pill w-100 text-center" style={{ backgroundColor: 'var(--color-white)', color: 'var(--color-primary-navy)', fontWeight: '700', padding: '1rem', fontSize: '0.95rem', boxShadow: '0 8px 20px rgba(0,0,0,0.1)' }}>
                Contact Us
              </Link>
            </div>
          </aside>

        </div>
      </section>

      {/* 3. PROCESS SECTION */}
      <section className="service-process-section bg-navy" style={{ paddingTop: '6rem', paddingBottom: '8rem' }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: '4rem' }}>
            <h2 style={{ color: 'var(--color-white)' }}>Our Deployment Methodology</h2>
          </div>
          <div className="process-steps">
            <div className="step-card">
              <h4>Site Assessment</h4>
              <p>We conduct a thorough, confidential review of your corporate risk profile and facility layout to identify specific vulnerabilities.</p>
            </div>
            <div className="step-card">
              <h4>Strategic Integration</h4>
              <p>Advance planning of access controls, patrol routes, and front-of-house logistics to ensure seamless, secure daily operations.</p>
            </div>
            <div className="step-card">
              <h4>Active Deployment</h4>
              <p>Deployment of our highly trained operatives, providing a constant, professional layer of security tailored to your business environment.</p>
            </div>
          </div>
        </div>
      </section>

      {/* 4. SLEEK FLOATING CTA BANNER */}
      <section style={{ backgroundColor: 'var(--color-white)', paddingTop: '4rem', paddingBottom: '6rem' }}>
        <div className="container">
          <div 
            className="sleek-cta-banner-override"
            style={{ 
            backgroundImage: `linear-gradient(to right, rgba(23, 44, 79, 0.95), rgba(23, 44, 79, 0.8)), url(${bannerImg})`,
            borderRadius: '16px',
            padding: '3rem 4rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
            gap: '2rem',
            flexWrap: 'wrap',
            position: 'relative',
            overflow: 'hidden'
          }}>

            <div style={{ textAlign: 'left', flex: '1', position: 'relative', zIndex: 2, minWidth: '300px' }}>
              <h2 style={{ color: 'var(--color-white)', marginBottom: '0.5rem', fontSize: '2.1rem', letterSpacing: '-0.5px' }}>Uncompromising Security Solutions</h2>
              <p style={{ color: 'var(--color-secondary-light)', fontSize: '1rem', margin: 0, maxWidth: '600px', lineHeight: '1.6' }}>
                Discover how our highly trained personnel can deliver bespoke security solutions tailored to your organisation.
              </p>
            </div>
            
            <div style={{ position: 'relative', zIndex: 2, flexShrink: 0 }}>
              <Link to="/contact" className="btn btn-pill" style={{ 
                backgroundColor: 'var(--color-white)', 
                color: 'var(--color-primary-navy)', 
                fontWeight: '700', 
                padding: '1rem 2.5rem', 
                fontSize: '0.95rem',
                boxShadow: '0 8px 20px rgba(0,0,0,0.1)'
              }}>
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default CorporateSecurity;